import { render, staticRenderFns } from "./socials.vue?vue&type=template&id=317f797c&scoped=true&"
import script from "./socials.vue?vue&type=script&lang=js&"
export * from "./socials.vue?vue&type=script&lang=js&"
import style0 from "./socials.vue?vue&type=style&index=0&id=317f797c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317f797c",
  null
  
)

export default component.exports